// components/CustomModal.tsx
import React from "react";
import { Dialog } from "primereact/dialog";
import classes from "./CustomModal.module.scss";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const CustomModal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      modal
      dismissableMask
      header={null}
      style={{ maxHeight: "90vh", wordBreak: "break-all" }}
      contentStyle={{ maxHeight: "100vh", overflowY: "auto", padding: "1rem" }}
      className={classes.modalCM}
    >
      {/* Modal içindeki tüm img etiketlerine responsive stil */}
      <style>{`

       .p-dialog-content img {
          height: auto !important;
          object-fit: contain;
          display: block;
        margin:0 auto;
        }
      `}</style>

      {children}
    </Dialog>
  );
};

export default CustomModal;
